import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./Navbar.css";

const menuItems = [
  { name: "Home", link: "/" },
  {
    name: "About Us",
    submenu: [
      { name: "College", link: "/about-us" },
      { name: "Founder", link: "/founder" },
      { name: "Principal", link: "" },
      { name: "Vasavi Academy", link: "" },
      { name: "Strategic Plan", link: "" },
      { name: "Annual Reports", link: "" },
      { name: "Board of Governors", link: "" },
      { name: "Organogram", link: "" },
    ],
  },
{
    name: "Departments",
    submenu: [
      { name: "Civil  Engineering", link: "departments" },
      { name: "Computer Science Engg", link: "" },
      { name: "Electronics Communication", link: "" },
      { name: "Electrical Electronics Engg", link: "" },
      { name: "Mechanical  Engineering", link: "" },
      { name: "Information Technology", link: "" },
      { name: "Computer Applications", link: "" },
      {
        name: "Humanities &amp; Basic Sci",
        submenu: [
          { name: "Chemistry", link: "" },
          { name: "HSS", link: "" },
          { name: "Physics", link: "" },
          { name: "Mathematics", link: "" },
        ],
      },
     
    ],
  },

  {
    name: "Academics",
    submenu: [
      { name: "Academic Council", link: "" },
      { name: "Almanac", link: "" },
      { name: "Activity Calendar", link: "" },
      { name: "Administrative Manual", link: "" },
      { name: "Examinations (CIE & SEE)", link: "" },
      { name: "Courses Offered", link: "" },
      { name: "Public holidays-2025", link: "" },
      { name: "Syllabus", link: "" },
      { name: "Value-Added Courses", link: "" },
      { name: "Board of Studies", link: "" },
      { name: "Committees", link: "" },
      { name: "PO and PSO attainment", link: "" },
    ],
  },
  {
    name: "Admissions",
    submenu: [
      { name: "Admissions Manual", link: "" },
      { name: "Admission Analysis", link: "" },
      { name: "TGEAPCET cutoff Ranks", link: "" },
      { name: "JEE Main AIR cutoff Ranks (Category B)", link: "" },
    ],
  },
  {
    name: "Facilities",
    submenu: [
      { name: "Bank", link: "" },
      { name: "Cafeteria", link: "" },
      { name: "Computer Center", link: "" },
      { name: "Divyangjan Facilities", link: "" },
      { name: "Media Center (e-content)", link: "" },
      { name: "Common Rooms", link: "" },
      { name: "Smart, ICT enabled classrooms", link: "" },
      {
        name: "Green Initiatives",
        submenu: [
          { name: "Green Practices", link: "" },
          { name: "Solar Panels", link: "" },
          { name: "LED", link: "" },
          { name: "Waste Management", link: "" },
          { name: "Rain Water Harvesting Pits", link: "" },
        ],
      },
      { name: "Games and Sports", link: "" },
      { name: "Language Labs", link: "" },
      { name: "Library", link: "" },
      { name: "Maintenance cell", link: "" },
      { name: "Medical Facility", link: "" },
      { name: "Transport", link: "" },
      { name: "Counselling", link: "" },
    ],
  },
 {
    name: "Placements",
    submenu: [
      { name: "Placements Dept", link: "" },
      { name: "Placements Information", link: "" },
      { name: "Studentwise Placements Information", link: "" },
      { name: "Placements  Info. Offcampus", link: "" },
      { name: "Recruiters", link: "" },
      { name: "Training", link: "" },
      { name: "Internships", link: "" },
      { name: "Student - Competitive Exams", link: "" },
      { name: "Career Counselling activities", link: "" },
      { name: "Industry  Linkages", link: "" },
      { name: "Capacity Development and Skill Enhancement", link: "" },
    ],
  },
{
    name: "Staff",
    submenu: [
      { name: "Civil Engineering", link: "" },
      { name: "Computer Science Engg.", link: "" },
      { name: "Electronics Communication", link: "" },
      { name: "Electrical Electronics Engg.", link: "" },
      { name: "Mechanical  Engineering", link: "" },
      { name: "Information  Technology", link: "" },
      {
        name: "Humanities Basic Sci",
        submenu: [
          { name: "Chemistry", link: "" },
          { name: "HSS", link: "" },
          { name: "Physics", link: "" },
          { name: "Mathematics", link: "" },
        ],
      },
      {
        name: "Functional Units Others",
        submenu: [
          { name: "Accounts", link: "" },
          { name: "Academic Exam Branch", link: "" },
          { name: "Administration", link: "" },
          { name: "Campus Maintainance", link: "" },
          { name: "Computer Center", link: "" },
          { name: "Examinations ", link: "" },
          { name: "DSW Office", link: "" },
          { name: "Games Sports", link: "" },
          { name: "Library", link: "" },
          { name: "Placement Cell [HR]", link: "" },
          { name: "Medical Center", link: "" },
        ],
      },
      
    ],
  },
 {
    name: "Campus Life",
    submenu: [
      { name: "Acumen - Technical  Symposium", link: "" },
      { name: "Extramural Engagements", link: "" },
      { name: "Extra Curricular Activities [Clubs]", link: "" },
      { name: "Euphoria - Cultural  Fete", link: "" },
      { name: "Kriti - Annual Art  Exhibition", link: "" },
      { name: "National Service  Scheme [NSS] ", link: "" },
      { name: "Street Cause", link: "" },
      { name: "Swayam - Entrepreneurship Cell", link: "" },
      { name: "Gender Equity", link: "" },
      { name: "Equity Action Plan", link: "" },
      { name: "Professional Bodies", link: "" },
      { name: "Traditional Day", link: "" },
    ],
  },

  { name: "Alumni", link: "" },
  { name: "Teqip", link: "" },
  { name: "R & D Cell", link: "" },
  { name: "Feedback", link: "" },
  { name: "Contact Us", link: "" },
];

// Recursive menu render
const renderMenu = (items) => {
  return items.map((item) => {
    if (item.submenu) {
      return (
        <li className="dropdown-submenu" key={item.name}>
          <a
            href={item.link || "#"}
            className="dropdown-item dropdown-toggle"
            data-bs-toggle="dropdown"
          >
            {item.name}
          </a>
          <ul className="dropdown-menu">{renderMenu(item.submenu)}</ul>
        </li>
      );
    } else {
      return (
        <li key={item.name}>
          <a className="dropdown-item" href={item.link || "#"}>
            {item.name}
          </a>
        </li>
      );
    }
  });
};

export default function Navbar() {
  return (
    <div className="menus-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <nav className="navbar navbar-expand-lg navbar-light">
              <div className="container-fluid">

                {/* Mobile Toggle Button */}
                <button
                  className="navbar-toggler"
                  type="button"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#mobileMenu"
                >
                  <span className="navbar-toggler-icon"></span>

                    {/* <span>-</span>
                    <span>-</span>
                    <span>-</span> */}
                </button>

                {/* Desktop Menu */}
                  <div className="collapse navbar-collapse d-none d-lg-block">
                    <ul className="navbar-nav mx-auto">
                      {menuItems.map((menu) =>
                        menu.submenu ? (
                          <li className="nav-item dropdown" key={menu.name}>
                            <a
                              href={menu.link || "#"}
                              className="nav-link dropdown-toggle"
                              data-bs-toggle="dropdown"
                            >
                              {menu.name}
                            </a>
                            <ul className="dropdown-menu">{renderMenu(menu.submenu)}</ul>
                          </li>
                        ) : (
                          <li className="nav-item" key={menu.name}>
                            <a className="nav-link" href={menu.link || "#"}>
                              {menu.name}
                            </a>
                          </li>
                        )
                      )}
                    </ul>
                  </div>

                  {/* Offcanvas Mobile Menu */}
                  <div
                    className="offcanvas offcanvas-start d-lg-none"  // ✅ Only show on mobile
                    tabIndex="-1"
                    id="mobileMenu"
                  >
                    <div className="offcanvas-header">
                      <h5 className="offcanvas-title">Menu</h5>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="offcanvas"
                      ></button>
                    </div>
                    <div className="offcanvas-body">
                      <ul className="navbar-nav">
                        {menuItems.map((menu) =>
                          menu.submenu ? (
                            <li className="nav-item dropdown" key={menu.name}>
                              <a
                                href={menu.link || "#"}
                                className="nav-link dropdown-toggle"
                                data-bs-toggle="dropdown"
                              >
                                {menu.name}
                              </a>
                              <ul className="dropdown-menu">{renderMenu(menu.submenu)}</ul>
                            </li>
                          ) : (
                            <li className="nav-item" key={menu.name}>
                              <a className="nav-link" href={menu.link || "#"}>
                                {menu.name}
                              </a>
                            </li>
                          )
                        )}
                      </ul>
                    </div>
                  </div>


              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
}
